import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

export enum DropDownListType {
  Float = 'float',
  Embedded = 'embedded',
}

export enum DropDownListSelectedBy {
  Check = 'Check',
  RadioButton = 'RadioButton',
}

export interface DropDownListOption {
  Id: string;
  Title: string;
  Subtitle?: string;
  Icon?: Icon;
  Image?: string;
}

export interface DropDownListPaginator {
  TotalOfItems: number;
  TotalOfPages: number;
  CurrentPage: number;
  PageSize: number;
  StartPage: number;
  EndPage: number;
  StartIndex: number;
  EndIndex: number;
  Pages: number[];
}

export const DropDownListDefaultValues = {
  Type: DropDownListType.Float,
  SelectedBy: DropDownListSelectedBy.Check,
};

export const DropDownListPagination = {
  DefaultLimit: 15,
  DefaultMaxPage: 100,
};
